import React, {useCallback, useEffect, useState} from 'react';
import styles from './styles.module.scss';
import {Button} from '@chakra-ui/react';
import {tabs} from './config';
import Text from 'components/typografy/text';
import classNames from 'classnames';
import {useLocation} from 'react-router-dom';

const Tabs: React.FC = () => {
  const location = useLocation();
  const {activeTab} = location.state || {};
  const [tabIndex, setTabIndex] = useState(Boolean(activeTab) ? +activeTab : 0);

  const ActiveConponent = useCallback(() => {
    const Component = tabs[tabIndex].Component;
    return <Component />;
  }, [tabIndex]);

  const onTabClick = (index: number) => {
    return () => setTabIndex(index);
  };

  useEffect(() => {
    return () => {
      window.history.replaceState({}, '');
    };
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        {Object.values(tabs).map((tab, index) => {
          return (
            <Button
              key={index}
              className={classNames(styles.btn, {[styles.active]: index === tabIndex})}
              onClick={onTabClick(index)}
            >
              <Text variant={'medium'}>{tab.title as string}</Text>
            </Button>
          );
        })}
      </div>
      <div className={styles.bottom}>
        <ActiveConponent />
      </div>
    </div>
  );
};

export default Tabs;
